import { DataService, ApiService } from "../service";

export class PartnerService {
    static async saveEnroll(fullName: string, phone: number, address: string) {
        return await DataService.post(`${ApiService.EngineerApi}/enroll/saveEnroll`, {
            fullName,
            phone,
            address
        }, { noShowErr: true })
    }
}
